import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="App">
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0F281A",
              color: "#F7F5F0",
              border: "1px solid rgba(212,175,55,0.4)",
              borderRadius: "2px",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
